import React, { useEffect, useState } from 'react';
import {
  Home,
  Video,
  Folder,
  ChevronRight,
  ExternalLink,
  FileText,
  BookOpen,
  LayoutGrid,
  StickyNote,
  CalendarDays,
  Shield,
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { adminService } from '../../../services/admin.service.ts';

function Sidebar() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void adminService.checkStatus().then((ok) => {
      if (!cancelled) setIsAdmin(ok);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const menuItems = [
    { id: 'home', label: 'Panel', icon: Home, path: '/dashboard' },
    { id: 'meetings', label: 'Toplantılar', icon: Video, path: '/plans' },
    { id: 'calendar', label: 'Takvim', icon: CalendarDays, path: '/calendar' },
    { id: 'agenda-pool', label: 'Gündem Havuzu', icon: BookOpen, path: '/agenda-pool' },
    { id: 'recordings', label: 'Kayıtlar', icon: Folder, path: '/recordings' },
    { id: 'summaries', label: 'Toplantı Özetlerim', icon: FileText, path: '/summaries' },
  ];

  const productItems = [
    { label: 'Beyaz Tahtalar', icon: LayoutGrid, path: '/products/whiteboards' },
    { label: 'Notlar', icon: StickyNote, path: '/products/notes' },
    { label: 'Klipler', icon: ExternalLink, path: '/products/clips' },
    { label: 'Dokümanlar', icon: ExternalLink, path: '/products/documents' },
    { label: 'Görevler', icon: ExternalLink, path: '/products/tasks' },
  ];

  return (
    <div className="bg-slate-800/50 backdrop-blur-sm border border-white/10 rounded-xl p-4 xl:p-6 sticky top-20">
      <nav className="space-y-1 mb-6">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            location.pathname === item.path ||
            (item.path === '/plans' && location.pathname.startsWith('/plans')) ||
            (item.path === '/calendar' && location.pathname.startsWith('/calendar')) ||
            (item.path === '/agenda-pool' && location.pathname.startsWith('/agenda-pool'));
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                isActive
                  ? 'bg-purple-600 text-white'
                  : 'text-gray-300 hover:bg-white/5 hover:text-white'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="mb-6">
        <h3 className="px-4 text-xs font-semibold text-gray-500 uppercase mb-2">Ürünlerim</h3>
        <div className="space-y-1">
          {productItems.map((item, index) => {
            const Icon = item.icon;
            const isActive =
              location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
            return (
              <Link
                key={index}
                to={item.path}
                className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition ${
                  isActive
                    ? 'bg-purple-600/80 text-white'
                    : 'text-gray-300 hover:bg-white/5 hover:text-white'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="text-sm">{item.label}</span>
              </Link>
            );
          })}
          <Link
            to="/products"
            className="w-full flex items-center space-x-3 px-4 py-2 text-gray-400 hover:text-white rounded-lg transition text-sm"
          >
            <span>Daha Fazla Ürün Keşfedin</span>
          </Link>
        </div>
      </div>

      <div className="space-y-1 border-t border-white/10 pt-4">
        <Link
          to="/profile"
          className="w-full flex items-center space-x-3 px-4 py-2 text-gray-300 hover:bg-white/5 hover:text-white rounded-lg transition"
        >
          <ChevronRight className="w-4 h-4" />
          <span className="text-sm">Hesabım</span>
        </Link>
        {isAdmin && (
          <Link
            to="/admin"
            className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition ${
              location.pathname.startsWith('/admin')
                ? 'bg-purple-600/80 text-white'
                : 'text-gray-300 hover:bg-white/5 hover:text-white'
            }`}
          >
            <Shield className="w-4 h-4" />
            <span className="text-sm">Yönetici</span>
          </Link>
        )}
        <button
          type="button"
          className="w-full flex items-center space-x-3 px-4 py-2 text-gray-300 hover:bg-white/5 hover:text-white rounded-lg transition text-left"
        >
          <ChevronRight className="w-4 h-4" />
          <span className="text-sm">Destek</span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
